<div class="next-nav" (keydown)="onKeyDown($event)">
  <nav class="next-nav__main" id="main-navigation" [ngClass]="'theme-' + theme" data-test-id="new-nav-main-part">
    <top-section-nav class="next-nav__main__top-section-nav" [activeScreen]="activeScreen" [screens]="screens" [showHomeActionsBadge]="showHomeActionsBadge$"></top-section-nav>
    <bottom-section-nav
      [unreadNotificationsCount]="unreadNotificationsCount"
      [unreadNotificationsCountAriaLabel]="unreadNotificationsCountAriaLabel"
      [screens]="screens"
      [settingsScreen]="settingsScreen"
      [showMarketplace]="showMarketplace$"
      [activeScreen]="activeScreen"></bottom-section-nav>
  </nav>
  <sub-navigation-v2 class="next-nav__sub" *ngIf="activeScreen" [activeScreen]="activeScreen"></sub-navigation-v2>
</div>
